export default __webpack_public_path__ + "static/logo-252b6d645815fb4ba7bce7e96d082262.svg";